<cc-box>
  <div box header class="number-details-header">
    {{'ORDER_NUMBER.DETAILS' | translate}}
  </div>
  <div box content class="number-details-content">

    <div class="column">
      <span class="text-title" translate>ORDER_NUMBER.SELECTED_NUMBER</span>
      <cc-msisdn [msisdn]="{
            label: (selectedMsisdn?.number | phoneNumber) || pricing.prefix,
            msisdn: pricing.city,
            isoCountry: pricing.countryCode
            }"></cc-msisdn>
    </div>

    <div class="price-wrapper">
      <div class="column">
        <span class="text-title" translate>ORDER_NUMBER.MONTHLY_FEE</span>
        <cc-price [price]="pricing.price" [isFree]="isFree()"></cc-price>
      </div>

      <div class="column">
        <span class="text-title" translate>ORDER_NUMBER.ONE_TIME_FEE</span>
        <cc-price [price]="pricing.priceSetup" [isFree]="isFree()"></cc-price>
      </div>
    </div>
  </div>
  <div translate box content class="documents-info" *ngIf="pricing.requiredDocuments?.length">
    ORDER_NUMBER.ADDITIONAL_INFORMATION
  </div>
</cc-box>
